import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const PackageSwitcherWrapper = styled(Flex)`
    flex-direction: column;
    width: 580px;
`;

export const PackageSwitcherHeader = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 15px 24px;
`;

export const PackageSwitcherTitleWrapper = styled(Flex)`
    flex-direction: column;
    gap: 8px;
`;

export const CloseIcon = styled(IconButton)``;

export const PackageSwitcherFooter = styled(Flex)`
    gap: 4px;
    padding: 8px 16px;
    justify-content: flex-end;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;
